module.exports = __webpack_public_path__ + "img/Icon-email_square.a65e1db9.png";